import React, { useCallback } from 'react'
import { EmblaOptionsType } from 'embla-carousel'  // https://www.embla-carousel.com/examples/predefined/
import useEmblaCarousel from 'embla-carousel-react'
import AutoScroll from 'embla-carousel-auto-scroll'
import {
  /*NextButton,
  PrevButton,*/
  usePrevNextButtons
} from './embla_buttons'
import { Section, Headshot, RecapTitle, Card, Embla, EmblaContainer, EmblaSlide, EmblaSlideNumber, EmblaViewport, /*EmblaControls, EmblaButtons,*/ CardColumn, BackgroundImage, RecapSubTitle } from './styles'
import ss1 from '../../assets/Recap/slideshow1.jpeg'
import ss2 from '../../assets/Recap/slideshow2.jpeg'
import ss3 from '../../assets/Recap/slideshow3.jpeg'
import ss4 from '../../assets/Recap/slideshow4.jpeg'
import ss5 from '../../assets/Recap/slideshow5.jpeg'
import ss6 from '../../assets/Recap/slideshow6.jpeg'
import ss7 from '../../assets/Recap/slideshow7.jpeg'
import ss8 from '../../assets/Recap/slideshow8.jpeg'

import background from '../../assets/FAQ/FAQ_BG.png';


type PropType = {
  slides: number[]
  options?: EmblaOptionsType
}

const images = [ss1, ss2, ss3, ss4, ss5, ss6, ss7, ss8]

const Slides = images.map((photo) => (
  <Card>
    <CardColumn>
      <Headshot src={photo} alt="Photograph from DubHacks 2024" loading="lazy"></Headshot>
    </CardColumn>
  </Card>
))

const EmblaCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    AutoScroll({ playOnInit: true })
  ])

  const {
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  const onButtonAutoplayClick = useCallback(
    (callback: () => void) => {
      const autoScroll = emblaApi?.plugins()?.autoScroll
      if (!autoScroll) return

      const resetOrStop =
        autoScroll.options.stopOnInteraction === false
          ? autoScroll.reset
          : autoScroll.stop

      resetOrStop()
      callback()
    },
    [emblaApi]
  )

  return (
    <Embla onClick={() => onButtonAutoplayClick(onNextButtonClick)}>
      <EmblaViewport ref={emblaRef}>
        <EmblaContainer>
          {slides.map((index) => (
            <EmblaSlide key={index}>
              <EmblaSlideNumber>
                <span>{Slides[index]}</span>
              </EmblaSlideNumber>
            </EmblaSlide>
          ))}
        </EmblaContainer>
      </EmblaViewport>
    </Embla>
  )
}


  
const Recap: React.FC = () => {
  const OPTIONS: EmblaOptionsType = { loop: true }
  const SLIDE_COUNT = 8
  const SLIDES = Array.from(Array(SLIDE_COUNT).keys())

  return (
    <Section>
      <BackgroundImage src={background} alt="clouds" />
      <RecapTitle>
        Thanks for a great DubHacks 2024!
      </RecapTitle>
      <RecapSubTitle>
        Swipe or tap to see photos from DubHacks 2024!
      </RecapSubTitle>
      <EmblaCarousel slides={SLIDES} options={OPTIONS}/>
    </Section>
    );
}
     
export default Recap;